export default {
  orderDidntGo: {
    en: 'Your ecommerce order didn\'t go through. {text}',
  },
  anErrorOccurred: {
    en: 'An error occurred due to insufficient funds. Please add more funds and try again',
  },
  tossIn: {
    en: 'Your order will be delivered with your upcoming subscription order',
  },
  ecommerce: {
    en: 'Your order will ship within 5 to 7 business days',
  },
  perfumeCaseText: {
    en: 'Your order will ship with your next month\'s subscription order',
  },
  subscription: {
    en: 'Your subscription order will ship {shippingText} from our facility',
  },
  coupon: {
    en: 'Your coupon was activated',
  },
  giftRedeem: {
    en: 'Your gift was activated',
  },
  giftSubscription: {
    en: 'Your gift was sent',
  },
  giftCard: {
    en: 'Your gift card was sent',
  },

  returnToSite: {
    en: 'Return to the site',
  },
}
